import * as React from 'react'

import LoadingCover from '../loadingCover'

import * as styles from './modalLoading.module.css'

export default () => (
  <div className={styles.root}>
    <LoadingCover />
  </div>
)
